<template>
  <div class="w-6 flex items-center justify-center">
    <pause-icon
      v-if="state.audioStatus === 'playing'"
      class="icon-2xl opacity-50"
      @click="audioPlayer?.pause()"
    />
    <play-icon v-else class="icon-2xl opacity-50" @click="onPlay" />
    <audio
      ref="audioPlayer"
      class="hidden"
      controls
      @ended="state.audioStatus = 'ended'"
      @playing="state.audioStatus = 'playing'"
      @pause="state.audioStatus = 'paused'"
      :src="url"
    />
  </div>
</template>

<script setup lang="ts">
import PlayIcon from "@/components/icon/playIcon.vue";
import PauseIcon from "@/components/icon/pauseIcon.vue";
import { reactive } from "vue";
import { ref } from "vue";
const audioPlayer = ref<HTMLAudioElement | null>(null);

interface State {
  audioStatus: "loading" | "playing" | "paused" | "ended";
  isPlaying: boolean;
  filterLanguageId: number;
}
const state = reactive<State>({
  audioStatus: "paused", // loading, playing, paused, ended
  isPlaying: false,
  filterLanguageId: 2,
});
defineProps({
  url: {
    type: String,
    required: true,
  },
});

// 事件回调
const onPlay = async () => {
  await audioPlayer.value!.play();
};
</script>
